import { Stack } from 'expo-router';
import { useTheme } from 'smoothie';

export default function SettingsLayout() {
    const theme = useTheme();

    return (
        <Stack
            screenOptions={{
                headerShown: false,
                contentStyle: {
                    backgroundColor: theme.background.get(),
                },
            }}
        ></Stack>
    );
}
